var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHIcon7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    clipPath: "url(#clip0_684_15800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5417 5.63428H8.95833C8.4981 5.63428 8.125 6.00737 8.125 6.46761V18.5509C8.125 19.0112 8.4981 19.3843 8.95833 19.3843H18.5417C19.0019 19.3843 19.375 19.0112 19.375 18.5509V6.46761C19.375 6.00737 19.0019 5.63428 18.5417 5.63428Z",
    stroke: "#FF8503",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 16.8843H5.625C5.29348 16.8843 4.97554 16.7526 4.74112 16.5182C4.5067 16.2837 4.375 15.9658 4.375 15.6343V4.38428C4.375 4.05276 4.5067 3.73481 4.74112 3.50039C4.97554 3.26597 5.29348 3.13428 5.625 3.13428H14.375C14.7065 3.13428 15.0245 3.26597 15.2589 3.50039C15.4933 3.73481 15.625 4.05276 15.625 4.38428V5.63428",
    stroke: "#FF8503",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 14.3843H1.875C1.54348 14.3843 1.22554 14.2526 0.991117 14.0182C0.756696 13.7837 0.625 13.4658 0.625 13.1343V1.88428C0.625 1.55276 0.756696 1.23481 0.991117 1.00039C1.22554 0.765973 1.54348 0.634277 1.875 0.634277H10.625C10.9565 0.634277 11.2745 0.765973 11.5089 1.00039C11.7433 1.23481 11.875 1.55276 11.875 1.88428V3.13428",
    stroke: "#FF8503",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 9.38428H16.875",
    stroke: "#FF8503",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 8.75928L11.25 9.38428L12.5 8.13428",
    stroke: "#FF8503",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 13.1343H16.875",
    stroke: "#FF8503",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 12.5093L11.25 13.1343L12.5 11.8843",
    stroke: "#FF8503",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 16.8843H16.875",
    stroke: "#FF8503",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 16.2593L11.25 16.8843L12.5 15.6343",
    stroke: "#FF8503",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_684_15800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHIcon7);
export default __webpack_public_path__ + "static/media/hIcon7.39c2e5b14ce87904a0868a79e5017d82.svg";
export { ForwardRef as ReactComponent };